<div
  class="relative flex flex-col sm:flex-row sm:p-4 xl:p-6 sm:pr-0 min-h-dvh pb-safe"
>
  @if (impersonationService.isImpersonating()) {
    <app-impersonation-banner
      class="fixed top-0 left-0 right-0 z-10001 w-full"
      [impersonationLabel]="impersonationLabel()"
      [isExerciseRoute]="isExerciseRoute()"
      [isAutoPlaybackMuted]="userAudioService.isAutoPlaybackMuted()"
      (backToHome)="shellService.navigateHome()"
      (stopImpersonation)="impersonationService.stopImpersonation()"
      (toggleAutoPlaybackMuted)="userAudioService.toggleAutoPlaybackMuted()"
    />
  }
  @if (showSidebar() && !hideSidebar()) {
    <app-sidebar
      class="sticky top-0 left-0 right-0 z-50"
      [collapsed]="collapsed()"
      (toggle)="toggleSidebar()"
    ></app-sidebar>
  }
  <div
    class="mx-auto w-full flex-1"
    [class.sm:pl-(--sidebar-collapsed)]="
      collapsed() && showSidebar() && !hideSidebar()
    "
    [class.sm:pl-(--sidebar-expanded)]="
      !collapsed() && showSidebar() && !hideSidebar()
    "
    [class.content-area-sidebar-expanded]="
      showSidebar() && !collapsed() && !hideSidebar()
    "
    [class.content-area-sidebar-collapsed]="
      showSidebar() && collapsed() && !hideSidebar()
    "
  >
    <!-- Welcome Header -->
    @if (showWelcomeHeader()) {
      <div
        class="sticky top-14 sm:top-6 left-0 right-0 z-50 flex items-center gap-2 md:gap-4 px-2 pt-2 sm:pt-0 max-w-[800px] mx-auto select-none"
        [class.top-2!]="hideSidebar()"
        [class.top-16]="impersonationService.isImpersonating()"
        [class.sm:top-14]="impersonationService.isImpersonating()"
        [style.pointer-events]="welcomeCardDisplayNone() ? 'none' : null"
      >
        <img src="tiger.gif" alt="tiger" class="-ml-4 md:ml-0" width="130" />
        <div
          class="welcome-card w-full rounded-3xl border-4 border-[#fc982f] bg-white p-4 shadow-[0_8px_32px_rgba(0,0,0,0.1)] md:p-6 animate-[bounceIn_0.8s_ease-out] transition-all duration-300"
          [class.opacity-0]="hideWelcomeCard()"
          [style.display]="welcomeCardDisplayNone() ? 'none' : null"
        >
          <div class="flex items-center gap-4">
            <div class="flex flex-col gap-2 flex-1">
              <h1 class="text-xl md:text-3xl font-bold text-gray-800" i18n>
                Hello, {{ userService.currentUser()?.firstName }}!
              </h1>
              <p class="text-gray-600 text-sm md:text-base" i18n>
                Ready for today's pronunciation challenge?
              </p>
            </div>
          </div>
        </div>
      </div>
    }
    <div
      class="content-area flex w-full h-full flex-1 sm:flex-initial transition-all duration-300 overflow-x-hidden"
    >
      <p-toast
        [breakpoints]="{ '767px': { width: '96%', right: '2%', left: '2%' } }"
      />
      <p-confirm-dialog />
      <div
        class="w-full flex-1 overflow-x-auto min-h-[calc(100vh-3.5rem)] sm:pl-2"
        [class.pt-10]="impersonationService.isImpersonating()"
      >
        <router-outlet></router-outlet>
        @if (!isExerciseRoute()) {
          <app-day-completed></app-day-completed>
        }
      </div>
    </div>
  </div>
  <app-store-banner></app-store-banner>
  <app-practice-onboarding-checklist />
</div>
